import FeaturedTitlesSwimlane from './FeaturedTitlesSwimlane';

export default FeaturedTitlesSwimlane;
